import FavoriteAPublicationButton from "atoms/buttons/favorite-a-publication-button";
import { Icons } from "atoms/constants/icons";
import PublicationRecord from "models/view-models/publication-record";
import UserPublicationFavoriteRecord from "models/view-models/user-publication-favorite-record";
import BigButton from "molecules/buttons/big-button";
import DeprecatedPublicationCard from "molecules/cards/deprecated-publication-card";
import PublicationSelectionModal from "organisms/modals/publication-selection-modal/publication-selection-modal";
import * as React from "react";
import { CollectionUtils } from "utilities/collection-utils";
import { useLocalization } from "utilities/hooks/use-localization";
import useModalActions from "utilities/hooks/use-modal-actions";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const BASE_CLASS_NAME = "c-favorite-publications";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface FavoritePublicationsProps {
    favoritePublications: PublicationRecord[];
    favorites: UserPublicationFavoriteRecord[];
    onChangeFavorites: (favorites: UserPublicationFavoriteRecord[]) => void;
}

// #endregion Interfaces

const FavoritePublications = (props: FavoritePublicationsProps) => {
    const { favoritePublications, favorites, onChangeFavorites } = props;

    const { t } = useLocalization();

    const {
        isOpen: isPublicationSelectionModalOpen,
        handleOpen: handlePublicationSelectionModalOpen,
        handleClose: handlePublicationSelectionModalClose,
    } = useModalActions();

    const cssClassName = [
        BASE_CLASS_NAME,
        CollectionUtils.isEmpty(favoritePublications) ? "-empty" : "",
    ].join(" ");

    // -----------------------------------------------------------------------------------------
    // #region Render
    // -----------------------------------------------------------------------------------------

    return (
        <div className={cssClassName}>
            <div className={`${BASE_CLASS_NAME}__view-all-publications`}>
                <BigButton
                    icon={Icons.Search}
                    onClick={handlePublicationSelectionModalOpen}>
                    <div
                        className={`${BASE_CLASS_NAME}__view-all-publications__button-content`}>
                        <div
                            className={`${BASE_CLASS_NAME}__view-all-publications__button-content__title`}>
                            {t("findAPublication")}
                        </div>
                        <div
                            className={`${BASE_CLASS_NAME}__view-all-publications__button-content__subtitle`}>
                            {t("searchAndBrowseTheLibrary")}
                        </div>
                    </div>
                </BigButton>
            </div>
            <label>{t("favorite_plural")}</label>
            {CollectionUtils.isEmpty(favoritePublications) && (
                <FavoriteAPublicationButton
                    onClick={handlePublicationSelectionModalOpen}
                />
            )}

            {CollectionUtils.hasValues(favoritePublications) && (
                <div className={`${BASE_CLASS_NAME}__cards`}>
                    {favoritePublications.map((p: PublicationRecord) => (
                        <DeprecatedPublicationCard
                            favorites={favorites}
                            key={p.id}
                            onChangeFavorites={onChangeFavorites}
                            publication={p}
                        />
                    ))}
                </div>
            )}
            <PublicationSelectionModal
                closeDialog={handlePublicationSelectionModalClose}
                favorites={favorites}
                isVisible={isPublicationSelectionModalOpen}
                onChangeFavorites={onChangeFavorites}
                onResultClick={() => {}}
            />
        </div>
    );

    // #endregion Render
};

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default FavoritePublications;

// #endregion Exports
